<template>
  <v-card class="mx-auto" light>


    <simpleTableComponent
      :headers="headers"
      :items="deparas"
      :pagina="pagina"
      :paginas="paginas"
      :totalRegistros="regTotal"
      :registrosPagina="regPagina"
      :search="search"
      :loading="loading"
      @changePage="changePage"
      @searchItem="searchItem"
      @agregarDepara="agregarDepara = true"
      @modificarDepara="modificarDepara"
    />

   

    <nuevoDeparaComponent
      v-if="agregarDepara"
      :mostrar="agregarDepara"
      @cancelar="agregarDepara = false"
      @deparaGuardado="deparaGuardado"
    />

    <modificarDeparaComponent
      v-if="editarDepara.mostrar"
      :mostrar="editarDepara.mostrar"
      :depara="editarDepara.depara"
      @cancelar="cancelarModificarDepara"
      @deparaModificado="deparaModificado"
    />
  </v-card>
</template>

<script>
import simpleTableComponent from "./deparaSimpleTable.vue";
import nuevoDeparaComponent from "./nuevoDepara.vue";
import modificarDeparaComponent from "./modificarDepara.vue";

import { cargarOficiosDeparaService } from "./depara.service";

export default {
  name: "listadoDepara",
  components: {
    simpleTableComponent,
    nuevoDeparaComponent,
    modificarDeparaComponent,
  },
  computed: {
    deparaList() {
      const deparas = [];
      let contador = this.pagina * this.regPagina - this.regPagina + 1;
      for (const depara of this.deparas) {
        const nuevoDepara = { numero: contador++, ...depara };
        deparas.push(nuevoDepara);
      }
      return deparas;
    },
  },
  watch: {
    /*"$route.query"(query) {
      if (query.page != this.page) this.pagina = query.page || 1;

      if (query.search) {
        if (query.search != this.search) this.search = query.search;
      }

      this.cargarDeparas();
    },*/
  },
  async mounted() {
    this.pagina = this.$route.query.page || 1;
    if (this.$route.query.search) {
      this.pagina = 1;
      this.search = this.$route.query.search;
    }
    this.cargarDeparas();
  },
  data: () => ({
    loading: false,
    search: "",
    pagina: 1,
    paginas: 2,
    regTotal: 0,
    regPagina: 20,
    headers: [
      // { text: '', value: 'options', sortable: false },
      { text: "Capturó", value: "capturo" },
      { text: "Fecha", value: "fecha" },
      { text: "De", value: "de" },
      { text: "Para", value: "para" },
      { text: "Asunto", value: "asunto" },
      { text: "Ver", value: "ver" },
    ],
    deparas: [],
    agregarDepara: false,
    editarDepara: {
      mostrar: false,
      depara: [],
    },
  }),
  methods: {
    async cargarDeparas() {
      this.deparas = [];
      try {
        this.loading = true;

        const sendData = {
          pagina: this.pagina,
          search: this.search,
        };

        const serverResponse = await cargarOficiosDeparaService(sendData);
        this.loading = false;


        if (!serverResponse.ok) throw Error(serverResponse.mensaje);
        else {
          this.deparas = serverResponse.deparas;
          this.regTotal = serverResponse.totalDeparas;
          this.paginas = Math.ceil(this.regTotal / this.regPagina);
        }
      } catch (error) {
        this.loading = false;
        this.$notificarError(error.message);
      }
    },
    changePage(page) {
      this.pagina = page;
      this.cargarDeparas();
    },
    searchItem(search) {
      this.search = search;
      this.pagina = 1;

      this.cargarDeparas();
    },
    deparaGuardado(nuevoDepara) {
      this.deparas.unshift(nuevoDepara);
      this.regTotal++;
      this.agregarDepara = false;
    },
    modificarDepara(idDepara) {
      this.editarDepara.depara = this.deparas.filter(
        (x) => x._id === idDepara
      )[0];

      this.editarDepara.mostrar = true;
    },
    cancelarModificarDepara() {
      this.editarDepara.mostrar = false;
      this.editarDepara.depara = [];
    },
    deparaModificado(nuevoDepara) {
      const index = this.deparas.filter((x) => x._id === nuevoDepara._id);
      this.deparas.splice(index, 1, nuevoDepara);

      this.editarDepara.mostrar = false;
      this.editarDepara.depara = [];
    },
  },
};
</script>

<style>
.link {
  text-decoration: none;
}
.disable-events {
  pointer-events: none;
  opacity: 0.2;
}
</style>